module.exports = __webpack_public_path__ + "static/media/IMG_2178-2.e09a06b2.jpg";